export const COLUMNS = Object.freeze({
  VERSION: 'Version',
  SENT: 'Sent',
  OPENED: 'Opened',
  CLICKED: 'Clicked',
  REPLIED: 'Replied',
});
